import React, { SVGProps } from "react";

export default function SupWalletDisconnect(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.5924 13.1995V10.0012H16.392V13.1995H15.5924Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.56537L17.4346 18L18 17.4346L17.2068 16.6415C17.6977 16.0264 17.9911 15.2469 17.9911 14.3988V5.20391H14.7929V2.00568H3.99889C3.59295 2.00568 3.21528 2.12669 2.89997 2.3346L2.56537 2L2 2.56537ZM3.48566 2.92029C3.64125 2.84651 3.81525 2.80524 3.99889 2.80524H13.9933V5.20391H5.76928L3.48566 2.92029ZM6.56883 6.00346H17.1916V14.3988C17.1916 15.0259 16.9853 15.6049 16.6368 16.0715L6.56883 6.00346Z"
        fill="currentColor"
      />
      <path
        d="M2 4.00457C2 3.90338 2.00752 3.80394 2.02203 3.70678L3.03907 4.72382C3.10746 4.81494 3.18852 4.896 3.27965 4.9644L4.31871 6.00346H3.99889C3.5489 6.00346 3.13363 5.85477 2.79956 5.60383V14.3988C2.79956 15.9443 4.05246 17.1972 5.598 17.1972H14.3931C14.7277 17.1972 15.0486 17.1385 15.3461 17.0308L15.9559 17.6406C15.4832 17.8689 14.9531 17.9968 14.3931 17.9968H5.598C3.61088 17.9968 2 16.3859 2 14.3988V4.00457Z"
        fill="currentColor"
      />
    </svg>
  );
}
